/**
 * Centralized TanStack Query keys for cache invalidation consistency.
 */

export const groupVoteKeys = {
  all: ['groupVotes'] as const,
  active: (organizerId: string | undefined) =>
    [...groupVoteKeys.all, 'active', organizerId] as const,
  detail: (voteId: string | undefined) =>
    [...groupVoteKeys.all, 'detail', voteId] as const,
};
